import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "467d6d05-bb81-4944-843a-f9395873986e", content: "Diaphragm mass", options: {} },
  { id: "95cc93e8-e3af-4204-8156-c41e1d5c0e0d", content: "Mechanical resistance", options: {} },
  { id: "395fa96d-eba8-47c1-b67d-72e34c55eec9", content: "Diaphragm stiffness", options: {} },
  { id: "6bab37bb-01b7-49dc-afa3-d5cb5ee891b1", content: "Electrical resistance", options: {} },
  { id: "3c06498f-c792-466d-9767-9d60fbabbb79", content: "Diaphragm surface", options: {} },
  { id: "67937602-bbd5-4cbb-b03b-4adbbc1a631f", content: "Ribbon length", options: {} },
];

export const task: Task = {
  id: "4f35292e-7378-479f-9cc9-213a156d0024",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "467d6d05-bb81-4944-843a-f9395873986e",
    "3c06498f-c792-466d-9767-9d60fbabbb79",
    "67937602-bbd5-4cbb-b03b-4adbbc1a631f",
  ],
};
